import React, { Component } from "react";
import PropTypes from "prop-types";
import CustomPropTypes from '../../utils/customPropTypes';
import GenericCarousel from "../GenericCarousel";
import styles from "../../../scss/components/Applications/Accessories";
export default class Accessories extends Component {
    static propTypes = {
        eyebrow: PropTypes.string,
        cards: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                description: PropTypes.string,
                image: CustomPropTypes.Image,
            })
        )
    }

    render() {

        return (
            <GenericCarousel {...this.props} controlType={GenericCarousel.ControlTypes.Accessories}></GenericCarousel>
        );
    }
}